import React, { useEffect, useState } from "react";
import "./setting.css";
import { Link } from "react-router-dom";
import DownImage from "../../images/icons/down.png";
import api from "../../api/api";
import apiUtil from "../../api/apiUtil";
import getToken from "../getToken";
import DefaultProfileImage from "../../images/DefaultProfileImage.png";

const Setting = () => {
  const [page, setPage] = useState("account");
  const [allowNoti, setAllowNoti] = useState(true);
  const [playSound, setPlaySound] = useState(true);
  const [user, setUser] = useState({});

  const onClickButton = (current_page) => {
    setPage(current_page);
  };

  const toggleAllowNoti = () => {
    setAllowNoti((prevState) => !prevState);
  };

  const togglePlaySound = () => {
    setPlaySound((prevState) => !prevState);
  };

  let brandId = localStorage.getItem("brandId");
  const getAdminInfo = () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const param = {
      userId: userData.userId,
      brandId: brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setUser({
              userName: response.data.data.userName,
              email: response.data.data.email,
              image: response.data.data.image,
            });
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const btnLogOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("orgLevel");
    window.location.href = "/login";
  };

  useEffect(() => {
    getAdminInfo();
  }, []);

  return (
    <div className="setting">
      <h4 className="title_text Setting_title">Account</h4>
      <div className="Header_Container">
        <button
          className={`Setting_Btn ${page === "account" ? "btn_active_setting" : ""
            }`}
          onClick={() => {
            onClickButton("account");
          }}
        >
          Account
        </button>
        <button
          className={`Setting_Btn ${page === "noti" ? "btn_active_setting" : ""
            }`}
          onClick={() => {
            onClickButton("noti");
          }}
        >
          Notification
        </button>
        <button
          className={`Setting_Btn ${page === "language" ? "btn_active_setting" : ""
            }`}
          onClick={() => {
            onClickButton("language");
          }}
        >
          Language
        </button>
      </div>

      {page === "account" && (
        <div className="user_profile">
          <div className="avator">
            <img
              src={user.image ? user.image : DefaultProfileImage}
              alt="profile_image"
              className="rounded-circle"
            />
          </div>
          <div className="user_info">
            <h3>{user.userName}</h3>
            <div className="user_email">{user.email}</div>
          </div>
          <div className=" d-block ms-auto">
            <div className="user_setting_links">
              <Link to="/account">
                <div className="account_btn">Manage</div>
              </Link>
              <button
                type="button"
                className="account_btn"
                onClick={() => btnLogOut()}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}

      {page === "noti" && (
        <div className="setting_page_holder">
          <h4 className=" title_text">Notification</h4>
          <div className="switchHolder">
            <div className="toggle-switch">
              <label htmlFor="allowNoti" className="allowNoti">
                Allow Notifications
              </label>
              <label htmlFor="switch" className={`switch ${!allowNoti && "closeSwitch"}`}>
                <input
                  id="switch"
                  type="checkbox"
                  name="allowNoti"
                  checked={allowNoti}
                  onChange={toggleAllowNoti}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="switchHolder">
            <div className="toggle-switch">
              <label htmlFor="playSound" className="playSound">
                Play sound for notifications
              </label>

              <label htmlFor="playSound" className={`switch ${!playSound && "closeSwitch"}`}>
                <input
                  id="playSound"
                  type="checkbox"
                  name="playSound"
                  checked={playSound}
                  onChange={togglePlaySound}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      )}

      {page === "language" && (
        <div className="setting_page_holder">
          <h4 className=" title_text">Language</h4>
          <div className="language switchHolder">
            <div className="toggle-switch">
              <label htmlFor="allowNoti" className="allowNoti">
                English (United State)
              </label>
              <img src={DownImage} className="dropdown_icon" alt="down_icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Setting;
